import { registerModal } from 'features/Modal/ModalRegistry'
import { showModal } from 'features/Modal/Modal.actions'
import { PhoneSystemNumberCreateFormModal } from './PhoneSystemNumberCreateFormModal'
import { INumberCreateFormData } from 'features/PhoneSystem/PhoneSystemNumberCreateForm'

export const modalType = 'PHONE_SYSTEM_NUMBER_CREATE_FORM_MODAL'
registerModal(modalType, PhoneSystemNumberCreateFormModal)
export const showPhoneSystemNumberCreateFormModal = (modalProps: INumberCreateFormData) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberCreateFormModal/PhoneSystemNumberCreateFormModal.action.ts